module.exports = __webpack_public_path__ + "img/success@2x.a329dad0.svg";